<template>
  <div class="hy-order">
    <div class="order-cont">
      <!--活动简介-->
      <div class="order-topTitle">
        <div class="title">
          <h5>{{conference.name}}</h5>
        </div>
        <div class="infotimes" style="margin-top:10px;" v-if="conference.organizers != ''">
          <span class="iconfont">&#xe671;</span>主办单位：{{conference.organizers}}
        </div>
        <!-- <div class="infotimes" v-if="conference.company != ''">
          <span class="iconfont">&#xe6bb;</span>承办单位：{{conference.company }}
        </div> -->
        <div class="infotimes infotimes_width_label_content" style="display: flex;" v-if="id != '5664' && conference.company != ''">
          <div class="label" style="white-space: nowrap">
              <span class="iconfont">&#xe6bb;</span>
              <span>承办单位：</span>
            </div>
            <div class="content" style="display: flex; flex-direction: column; flex: auto;">
              <div v-for="(i, index) in conference.company?.split(' ')" :key="index">{{ i }}</div>
            </div>
        </div>
        <div class="infotimes">
          <span class="iconfont">&#xe67f;</span>会议时间：{{conference.start_time,'Y-M-D'|formatDates}}~{{conference.end_time,'Y-M-D'|formatDates}}
        </div>
        <div class="infotimes">
          <span class="iconfont">&#xe64d;</span>会议地点：{{conference.region}}{{conference.specific_address}}
        </div>
      </div>
      <!--是否住宿-->
      <div class="order_piaozhong">
        <div class="pz_title">
          <h5>填写入住人信息</h5>
        </div>
        <div class="order_cell" v-if="hotel.isIn == '1'">
          <div class="order_cell_items" v-for="(items,index) in hotel.list" :key="index">
            <div class="order_pxTitle" :class="cartbox.hotel[index].isShow == 1 ?'active':''">
              <h5 class="px_left"><span></span>{{items.name}}</h5>
           <!--   <span class="iconfont zs_icon" v-html="cartbox.hotel[index].isShow == 1 ? '&#xe60f;':'&#xe614;'"></span>-->
            </div>
            <div class="piao_list" v-if="cartbox.hotel[index].isShow == 1">
              <div class="piao_items" v-for="(items2,index2) in items.room" :key="index2">
                <h5 class="piao_name">{{items2.hotel_type}}</h5>
                <div class="piao_info" v-if="cartbox.hotel[index].list[index2].quantity == 0">
                  {{items2.explain == '' ?'暂无说明':items2.explain}}
                </div>
                <div class="piao_timeNameList" v-else>
                  <div class="tm_items" v-for="(items3,index3) in cartbox.hotel[index].list[index2].people_list" :key="index3">
                    <div class="p_title" v-if="index3 > 0">
                      请填写第 {{index3+1}} 间房入住人信息
                    </div>
                    <div class="p_times" @click="open_calendar([index,index2,index3],{type:'range',default_date:[items3.start_time,items3.end_time],max_range:cartbox.hotel[index].list[index2].day})">
                    <!--<div class="p_times">-->
                      <div class="t_l">
                        <h5>入住时间</h5>
                        <div>
                          <span>{{items3.start_time ,'M月D日'|formatDates}}</span>{{items3.start_time ,'周'|formatWeekDate}}
                        </div>
                      </div>
                      <div class="t_l">
                        <h5>离店时间</h5>
                        <div>
                          <span>{{items3.end_time,'M月D日'|formatDates}}</span>{{items3.end_time ,'周'|formatWeekDate}}
                        </div>
                      </div>
                      <div class="t_r">
                        共 {{items3.day}} 晚 <span class="iconfont">&#xe699;</span>
                      </div>
                    </div>
                    <div class="p_names">
                      <van-field :class="items3.is_required ?'':'active'" v-model="items3.name1" label="住宿人1：" placeholder="请填写入住人姓名" @blur="blur(1)"/>
                      <van-field  v-if="items2.member_num > 1" :class="items3.is_required2 ?'':'active'"  v-model="items3.name2" label="住宿人2：" placeholder="请填写入住人姓名" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--报名须知-->
      <div class="order_xuzhi">
        <div class="title">
          <h5>报名须知</h5>
        </div>
        <div class="xuzhi_info">
          {{conference.ticket_desc}}
        </div>
      </div>
    </div>
    <!--订单页底部提交栏-->
    <div class="order_addbtnbox">
      <div class="addbox">
        <div class="r" style="width:100%;">
          <span class="order_btn" @click="addPiaoCont()">保存信息</span>
        </div>
      </div>
    </div>
    <!--底部按钮-->
    <template v-if="Object.keys(conference).length != 0">
      <footerFixed :id="conference.id" :jump-page="conference.jump_page"/>
  </template>

    <!--Calendar 日历-->
    <div class="vanCalendar">
      <van-calendar v-model="vanCalendar.v_model" :type="vanCalendar.type" :title="vanCalendar.title" :min-date="vanCalendar.min_date" :max-date="vanCalendar.max_date" :default-date="vanCalendar.default_date" :poppable="vanCalendar.poppable" :show-confirm="vanCalendar.show_confirm" :confirm-text="vanCalendar.confirm_text" :position="vanCalendar.position" :close-on-click-overlay="vanCalendar.close_on_click_overlay" :max-range="vanCalendar.max_range"  :allow-same-day="vanCalendar.allow_same_day" :range-prompt="vanCalendar.range_prompt" @confirm="calendar_confirm" style="z-index:2010!important;" />
    </div>
  </div>
</template>


<script>
  import {
    formatDates,
    formatWeekDate
  } from "../../assets/js/date";
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        id: '',
        order_show: false,
        footerNav: false,
        //日期选择公共配置
        vanCalendar: {
          type: 'single', //single表示选择单个日期， multiple表示选择多个日期， range表示选择日期区间
          title: '日期选择',
          min_date: new Date(), //最小日期
          max_date: new Date(new Date().getTime() + 90 * 24 * 3600 * 1000), //最大日期
          default_date: new Date(), //默认选中的日期 date|| date[时间戳]
          poppable: true, //是否以弹层的形式展示日历
          show_confirm: true, //是否展示确认按钮
          confirm_text: '确定', //按钮文字
          v_model: false, //是否显示日历弹窗
          position: 'bottom', //弹出位置，可选值为 top right left
          close_on_click_overlay: true, //是否在点击遮罩层后关闭
          max_range: '', //最多可选天数
          range_prompt:'',//超过最多可选天数时的提示文案
          allow_same_day: false, //是否允许日期范围的起止时间为同一天
          isOndata: '',
        },
        conference:{},
        //酒店信息
        hotel: {
          isIn: '1',
          list: []
        },
        //购物车信息
        cartbox: {
          hotel: [],
        }
      };
    },
    /* 时间过滤 */
    filters: {
      formatDates, //调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
      formatWeekDate //
    },
    created: function() {
      var _this = this;
      _this.id = _this.$route.params.id;
      _this.loadEnroll();
      _this.$WXConfig.wxShowMenu({ifshare:true,that:_this,data:''});
    },
    methods: {
      blur(val){
        var _this = this;
        for (var i = 0; i < _this.cartbox.hotel.length; i++) {
          var lists = _this.cartbox.hotel[i];
          for (var j = 0; j < lists.list.length; j++) {
            var lists2 = lists.list[j];
            for (var h = 0; h < lists2.people_list.length; h++) {
              var hotelbox = _this.cartbox.hotel[i].list[j].people_list[h];
         /*     if(val == 1){*/
                if (hotelbox.name1 == '' ) {
                  hotelbox.is_required = false;
                  _this.$toast('请填写住宿人姓名');
                  status = false;
                }else{
                  hotelbox.is_required = true;
                  status = true;
                }
              /*}else{
                if(hotelbox.name2 == ''){
                  hotelbox.is_required2 = false;
                  _this.$toast('请填写住宿人姓名');
                  status = false;
                  return false;
                }
                else{
                  hotelbox.is_required2 = true;
                  status = true;
                }
              }*/
            }
          }
        }
      },
      //banner跳转方法
      goPath(path) {
        this.$router.push(path)
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      //加载初始化内容
      loadEnroll() {
        var _this = this;
        let url = "/ac1/conference/addHotelPage";
        let params = {
          id: _this.id
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.conference = res.posts.conference;

            //酒店信息数据转化
            var box1 = []; //box1 酒店信息储存
              var indexbox = res.posts.hotel;
              var box3 = {
                end_time: indexbox.hotel.h_end_time,
                explain: '',
                hotel_type: indexbox.hotel.hotel_type,
                member_num: indexbox.hotel.member_num,
                id: indexbox.id,
                price: indexbox.hotel.price,
                quantity: 1,
                sold_num: 1,
                start_time: indexbox.hotel.h_start_time,
              };
            box1.push({
                  name: indexbox.hotel.h_name,
                  conference_id: indexbox.hotel.conference_id,
                  hotel_id: indexbox.hotel.hotel_id,
                  room: [box3]
                });
            //酒店信息赋值
            _this.hotel.list = box1;
            var nums = 1;
            _this.hotel.list.forEach(v => {
              var list = [];
              var dataTime = new Date().getTime();
              for (var i = 0; i < v.room.length; i++) {
                list.push({
                  id: v.room[i].id,
                  name: v.room[i].hotel_type,
                  max_num: '1',
                  min_date: v.room[i].start_time,
                  max_date: v.room[i].end_time,
                  price: v.room[i].price,
                  quantity: 1,
                  remaining_num: (v.room[i].quantity - v.room[i].sold_num),
                  people_list: [{
                    id: v.room[i].id,
                    type:21,
                    name1:res.posts.hotel.name.name1,
                    is_required:true,
                    is_required2:true,
                    name2:res.posts.hotel.name.name2,
                    start_time:res.posts.hotel.start_time,
                    end_time:res.posts.hotel.end_time,
                    day:Math.floor((res.posts.hotel.end_time-res.posts.hotel.start_time)/(24 * 3600)),
                  }],
                  day: Math.floor(((res.posts.hotel.end_time-res.posts.hotel.start_time)/(24 * 3600))+1)
                });
              }
              _this.cartbox.hotel.push({
                hotel_id: v.hotel_id,
                isShow: nums,
                list: list
              });
              nums = 0;
            });

          }
        });
      },
      show_orderBox() {
        this.order_show = !this.order_show;
      },
      formatDate(date) {
        return `${date.getFullYear()} - ${date.getMonth() + 1} - ${date.getDate()}`;
      },
      //日历选择器展示
      open_calendar(i, n) {
        var _this = this;
        if(Number(_this.cartbox.hotel[0].list[0].price) > 0){
          return false;
        }
        _this.vanCalendar.v_model = true;
        _this.vanCalendar.type = n.type;
        _this.vanCalendar.default_date = [new Date(n.default_date[0] * 1000), new Date(n.default_date[1] * 1000)];
        _this.vanCalendar.max_range ='' /*n.max_range*/;
        _this.vanCalendar.isOndata = _this.cartbox.hotel[i[0]].list[i[1]].people_list[i[2]];
        _this.vanCalendar.min_date = new Date(_this.cartbox.hotel[i[0]].list[i[1]].min_date * 1000);
        _this.vanCalendar.max_date = new Date(_this.cartbox.hotel[i[0]].list[i[1]].max_date * 1000);
      },
      //日历选择完1
      calendar_confirm(e) {
        // console.log(e);
        var _this = this;
        _this.vanCalendar.v_model = false;
        _this.vanCalendar.isOndata.start_time = parseInt(new Date(e[0]).getTime() / 1000);
        _this.vanCalendar.isOndata.end_time = parseInt(new Date(e[1]).getTime() / 1000);
        _this.vanCalendar.isOndata.day = (new Date(e[1]).getTime() - new Date(e[0]).getTime()) / (24 * 3600 * 1000);

      },
      //提交订单
      addPiaoCont() {
        var _this = this;
        var status = true;
        for (var i = 0; i < _this.cartbox.hotel.length; i++) {
          var lists = _this.cartbox.hotel[i];
          for (var j = 0; j < lists.list.length; j++) {
            var lists2 = lists.list[j];
            for (var h = 0; h < lists2.people_list.length; h++) {
              var hotelbox = _this.cartbox.hotel[i].list[j].people_list[h];
              if (hotelbox.name1 == '') {
                hotelbox.is_required = false;
                _this.$toast('请填写住宿人姓名');
                status = false;
              }else{
                hotelbox.is_required = true;
                status = true;
              }
             /* if(hotelbox.name2 == ''){
                hotelbox.is_required2 = false;
                _this.$toast('请填写住宿人姓名');
                status = false;
                return false;
              }
              else{
                hotelbox.is_required2 = true;
                status = true;
              }*/
            }
          }
        }
        if (status) {
          let url = "/ac1/conference/hotelMember/save";
          let params = {
            id:_this.cartbox.hotel[0].list[0].people_list[0].id,
            name1:_this.cartbox.hotel[0].list[0].people_list[0].name1,
            name2:_this.cartbox.hotel[0].list[0].people_list[0].name2,
            start_time:_this.cartbox.hotel[0].list[0].people_list[0].start_time,
            end_time:_this.cartbox.hotel[0].list[0].people_list[0].end_time
          };
          _this.$post(url, params).then(res => {
            if (res.code == "1") {
              _this.$toast(res.msg);
              setTimeout(function(){
                _this.$router.go(-1);
              },1000)
            } else {
              _this.$toast(res.msg);
            }
          }, function(res) {
            _this.$toast(res.msg);
          });
        }
      }
    },
    mounted() {}
  }
</script>
<style lang="less" scoped>

</style>
</style>
